import React from 'react';
import { Award, Heart, Users, Cpu, ArrowRight } from 'lucide-react';
import { aboutFeatures, servingAreas } from '../data/mock';

const iconMap = {
  Award,
  Heart,
  Users,
  Cpu,
};

const AboutSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Label */}
        <div className="text-center mb-4">
          <span className="text-cyan-600 font-semibold tracking-wider uppercase text-sm">
            About Our Practice
          </span>
        </div>

        {/* Main Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16">
          Restoring Lives, One Smile at a Time
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Text Content */}
          <div>
            <div className="prose prose-lg text-gray-600 mb-8">
              <p className="leading-relaxed">
                Dentistry is more than teeth. Your relationship with your health care provider is key to quality of care. I believe in patient-centered, comprehensive, quality dental care, while building lasting relationships with each person.
              </p>
              <p className="leading-relaxed">
                Together, we can address your oral health concerns through education, prevention, and quality dental care. We are a family-centered practice, and love to take care of families when possible. I look forward to meeting you and empowering you take care of your dental health.
              </p>
              <p className="leading-relaxed">
                When I&apos;m not at the office, I enjoy spending time with my family. My husband David, our daughters Madison and Lois, and I are also avid foodies and adventurers. I love to read, travel, be outdoors, and just enjoy the company of loved ones.
              </p>
            </div>

            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <span>Schedule Your Visit</span>
              <ArrowRight size={18} />
            </button>
          </div>

          {/* Right Column - Doctor Info */}
          <div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://roseville-smile-revamp.lovable.app/assets/dr-yang-about-C4Bw9m2L.jpeg"
                alt="Dr. Maichou Yang, DDS - Roseville Dentist"
                className="w-full h-72 object-cover object-top"
              />
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-1">Dr. Maichou Yang</h3>
                <p className="text-cyan-600 font-medium">DDS - Family & Cosmetic Dentistry</p>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {aboutFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Award;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 bg-cyan-50 rounded-xl flex items-center justify-center mb-4">
                  <IconComponent className="text-cyan-600" size={24} />
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{feature.title}</h4>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Dental Room Image */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://roseville-smile-revamp.lovable.app/assets/dental-room-BxBTQ9YS.jpg"
            alt="Modern dental treatment room at Sunshine Dental Care"
            className="w-full h-64 md:h-80 object-cover"
          />
        </div>

        {/* Serving Areas */}
        <div className="mt-12 text-center">
          <h4 className="text-lg font-semibold text-gray-900 mb-4">Proudly Serving</h4>
          <p className="text-gray-600">
            {servingAreas.join(' • ')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
